<template>
  <div :class="['cms', _isMobile() ? 'mobile' : '']">
    <div class="cms-header">
      <h1>{{ cmsInfo.cmsTitile }}</h1>
      <div class="cms-info">
        <span class="gap">本文发布于：{{ cmsInfo.createTime }}</span>
        <!-- <a-divider type="vertical"></a-divider>
        <a-icon type="user" />
        <span class="gap">发布人：{{ cmsInfo.createBy }}</span>
        <a-divider type="vertical"></a-divider>
        <a-icon type="eye" />
        <span class="gap">浏览数：{{ cmsInfo.viewNum }}</span> -->
      </div>
    </div>

    <a-divider></a-divider>

    <div class="article-content" v-html="cmsInfo.cmsContent"></div>
    <div class="extra-file" v-if="cmsInfo.extraFile">
      <p>附件：</p>
      <p v-for="(v,k,i) in extraFilename" :key="i">
        <span>{{(i+1)}}. </span>
        <a :href="$store.getters.tenantInfo.qiniuDomain + '/' +k" target="_blank">{{v}}</a>
      </p>
    </div>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import {mixinDevice} from '@/utils/mixin.js'

export default {
  mixins: [mixinDevice],
  data() {
    return {
      cmsInfo: {},
      extraFilename: {}
    };
  },
  watch: {
    $route(to, from) {
      this.getCmsDetail()
    },
  },
  created() {
    this.getCmsDetail()
  },
  methods:{
    getCmsDetail(){
      getAction("/teaching/teachingCms/getCmsDetail?id=" + this.$route.query.id).then((res) => {
        if (res.success) {
          this.cmsInfo = res.result;
          this.extraFilename = JSON.parse(this.cmsInfo.extraFilename)
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.cms{
  border-radius: 10px;
  background: white;
  padding: 20px 0;
  margin: 20px 0;
  box-shadow:#c5c0c0 0px 0px 10px;
  min-height: 80vh;
}
.cms-header {
  margin-top: 20px;
  text-align: center;
  h1{
    margin: 0 50px;
  }
  .cms-info {
    color: gray;
  }
}

.gap {
  margin-left: 5px;
  margin-right: 20px;
  font-size: 14px;
}
.article-content {
  overflow: auto;
  padding: 20px 100px;
  /deep/img {
    max-width: 100%;
    height: auto;
  }
}
.extra-file{
  padding: 20px 100px;
}

.mobile{
  .cms-header{
    h1{
      margin: 0 10px;
    }
  }
  .article-content{
    padding: 20px 15px;
  }
}
</style>